import React from "react";
import {ImageButton} from "../imageButton/ImageButton";

interface ButtonProps {
    disabled?: boolean
    handleClick: () => void
}

export const EditButton: React.FC<ButtonProps> = ({
                                                      disabled = false,
                                                      handleClick
                                                  }) => {
    return <ImageButton
        disabled={disabled}
        onClick={handleClick}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M11.25 20.0002C11.25 19.586 11.5858 19.2502 12 19.2502H21C21.4142 19.2502 21.75 19.586 21.75 20.0002C21.75 20.4144 21.4142 20.7502 21 20.7502H12C11.5858 20.7502 11.25 20.4144 11.25 20.0002Z"
                  fill="currentColor"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M18 3.62891C17.6363 3.62891 17.2875 3.77338 17.0303 4.03056L4.67724 16.3837L4.03079 18.9694L6.61658 18.323L18.9697 5.9699C19.097 5.84256 19.198 5.69138 19.267 5.52501C19.3359 5.35863 19.3713 5.18031 19.3713 5.00023C19.3713 4.82014 19.3359 4.64182 19.267 4.47544C19.198 4.30907 19.097 4.1579 18.9697 4.03056C18.8423 3.90322 18.6912 3.80221 18.5248 3.73329C18.3584 3.66438 18.1801 3.62891 18 3.62891ZM15.9697 2.9699C16.5082 2.43142 17.2385 2.12891 18 2.12891C18.3771 2.12891 18.7505 2.20318 19.0988 2.34747C19.4472 2.49177 19.7637 2.70327 20.0303 2.9699C20.297 3.23652 20.5085 3.55305 20.6528 3.90142C20.7971 4.24978 20.8713 4.62316 20.8713 5.00023C20.8713 5.37729 20.7971 5.75067 20.6528 6.09903C20.5085 6.4474 20.297 6.76393 20.0303 7.03056L7.53035 19.5306C7.43423 19.6267 7.31379 19.6949 7.18192 19.7278L3.18192 20.7278C2.92634 20.7917 2.65597 20.7168 2.46969 20.5306C2.2834 20.3443 2.20851 20.0739 2.27241 19.8183L3.27241 15.8183C3.30538 15.6865 3.37357 15.566 3.46969 15.4699L15.9697 2.9699Z"
                  fill="currentColor"/>
        </svg>
    </ImageButton>
}
